import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import styled, { css } from 'styled-components';
import { noTextSelect } from '../../common/CssCommon';
import GridLayout from '../../common/GridLayout';
import Dialog from '../Dialog';
import { MdAddCircleOutline, MdRemoveCircle } from 'react-icons/md';
import { useState } from 'react';
import ActiveLinkDialogFooter from './ActiveLinkDialogFooter';

import picture_layout_thumbnail_1_1 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_1_1.png';
import picture_layout_thumbnail_2_1 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_2_1.png';
import picture_layout_thumbnail_2_2 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_2_2.png';
import picture_layout_thumbnail_2_3 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_2_3.png';
import picture_layout_thumbnail_2_4 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_2_4.png';
import picture_layout_thumbnail_2_5 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_2_5.png';
import picture_layout_thumbnail_2_6 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_2_6.png';
import picture_layout_thumbnail_3_1 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_3_1.png';
import picture_layout_thumbnail_3_2 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_3_2.png';
import picture_layout_thumbnail_3_3 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_3_3.png';
import picture_layout_thumbnail_3_4 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_3_4.png';
import picture_layout_thumbnail_3_5 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_3_5.png';
import picture_layout_thumbnail_3_6 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_3_6.png';
import picture_layout_thumbnail_3_7 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_3_7.png';
import picture_layout_thumbnail_3_8 from '../../../img/activeLink/imageGrid/picture_layout_thumbnail_3_8.png';
import { genPWCImageGrid } from '../../plugin/pwc/pwcApis';
import { insertActiveLink } from '../../plugin/activeLink';
import { usePOWebofficeSDKState } from '../../../context/poWebOfficeSDKContext';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../store/modules/dialog';
import { useGenNotificationPromise } from '../../notification/Notification';

const IMAGE_GRID_LAYOUTS = [
  {
    count: 1,
    layout: [{ name: 'template_image_grid_1_1', src: picture_layout_thumbnail_1_1 }]
  },
  {
    count: 2,
    layout: [
      { name: 'template_image_grid_2_1', src: picture_layout_thumbnail_2_1 },
      { name: 'template_image_grid_2_2', src: picture_layout_thumbnail_2_2 },
      { name: 'template_image_grid_2_3', src: picture_layout_thumbnail_2_3 },
      { name: 'template_image_grid_2_4', src: picture_layout_thumbnail_2_4 },
      { name: 'template_image_grid_2_5', src: picture_layout_thumbnail_2_5 },
      { name: 'template_image_grid_2_6', src: picture_layout_thumbnail_2_6 }
    ]
  },
  {
    count: 3,
    layout: [
      { name: 'template_image_grid_3_1', src: picture_layout_thumbnail_3_1 },
      { name: 'template_image_grid_3_2', src: picture_layout_thumbnail_3_2 },
      { name: 'template_image_grid_3_3', src: picture_layout_thumbnail_3_3 },
      { name: 'template_image_grid_3_4', src: picture_layout_thumbnail_3_4 },
      { name: 'template_image_grid_3_5', src: picture_layout_thumbnail_3_5 },
      { name: 'template_image_grid_3_6', src: picture_layout_thumbnail_3_6 },
      { name: 'template_image_grid_3_7', src: picture_layout_thumbnail_3_7 },
      { name: 'template_image_grid_3_8', src: picture_layout_thumbnail_3_8 }
    ]
  }
];

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  width: 529px;
  padding: 24px;
  ${noTextSelect}
`;

const DialogContents = styled.div`
  margin-bottom: 24px; ;
`;

const TitleWrapper = styled.div`
  height: 29px;
  font-size: 20px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin-bottom: 24px;
`;

const SelectImageWrapper = styled.div`
  width: 100%;
`;

const LayoutList = styled.div`
  width: 100%;
  height: 270px;
  padding: 3px;
  overflow-y: auto;
`;

const LayoutWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ selected }) =>
    selected &&
    css`
      border: 2px solid #0b8793;
    `}

  cursor: pointer;
`;

const ContentItem = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  & + & {
    margin-top: 24px;
  }
`;

const ContentLabel = styled.div`
  width: 100%;
  height: 26px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 6px;
`;

const ContentsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 121px;
`;

const ImageContentsWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const ImageRemover = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 50%;
  top: 50%;
  color: red;
  border-radius: 50%;
  background-color: white;
  transform: translate(-50%, -50%);
  &:hover {
    background: #0b8793;
    cursor: pointer;
    color: white;
  }
`;

const ImageLoadLabel = styled.label`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f2;
  border: none;
  &:hover {
    background: #0b8793;
    opacity: 0.4;
    cursor: pointer;
    color: white;
  }
`;

const loadImageInitial = {
  0: {},
  1: {},
  2: {}
};

export default function ActiveLinkImageGrid({ isShow }) {
  const conetentsWidth = '147px';
  const contentsHeight = '121px;';
  const supportImageExt = ['.jpg', '.png', '.gif'];
  const { t } = useTranslation();
  const poSDKContextState = usePOWebofficeSDKState();
  const dispatch = useDispatch();
  const notificationPromise = useGenNotificationPromise();

  const [images, setImages] = useState(loadImageInitial);
  const [selectedLayout, setSelectedLayout] = useState();

  const getLoadImageCount = () => {
    let count = 0;
    for (const prop in images) {
      if (images[prop] && images[prop].id) count++;
    }
    return count;
  };

  const selectLayout = (e) => setSelectedLayout(e.currentTarget.getAttribute('name'));

  const getLayout = () => {
    const found = IMAGE_GRID_LAYOUTS.find((item) => item.count === getLoadImageCount());
    if (found) {
      return found.layout.map((img) => (
        <ContentsWrapper key={img.name}>
          <LayoutWrapper
            name={img.name}
            onClick={selectLayout}
            selected={selectedLayout === img.name}>
            <img src={img.src} alt={img.name} width={conetentsWidth} height={contentsHeight}></img>
          </LayoutWrapper>
        </ContentsWrapper>
      ));
    }
    return null;
  };

  const loadImage = (e) => {
    const uploadInfo = e.currentTarget;
    const file = uploadInfo.files[0] || null;
    if (file) {
      const index = e.currentTarget.getAttribute('index');
      e.currentTarget.value = null;
      const reader = new FileReader();
      reader.onload = (e) => {
        setImages({ ...images, [index]: { id: uuidv4(), src: e.target.result, file: file } });
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (e) => {
    const index = e.currentTarget.getAttribute('value');
    setImages({ ...images, [index]: {} });
  };

  const checkValid = () => {
    if (getLoadImageCount() > 0 && selectedLayout) return true;
    return false;
  };

  const onClickSubmit = () => {
    if (checkValid()) {
      genPWCImageGrid({
        images: Object.values(images).map((img) => img.file),
        layoutType: selectedLayout
      })
        .then((pwcURL) => insertActiveLink(poSDKContextState, pwcURL))
        .then(() => {
          dispatch(closeDialog());
        });
    } else {
      notificationPromise({
        title: t('Common.Notification'),
        message: t('ActiveLink.VoteErrorMessage'),
        btn: {
          confirm: {
            text: t('Common.Confirm')
          }
        },
        showCloseBtn: false
      });
    }
  };

  const getImageAreaContents = () => {
    const contents = [];
    for (const prop in images) {
      const img = images[prop];
      if (img && img.id) {
        contents.push(
          <ContentsWrapper key={prop}>
            <ImageContentsWrapper>
              <img src={img.src} alt="" width={conetentsWidth} height={contentsHeight}></img>
              <ImageRemover onClick={removeImage} value={prop}>
                <MdRemoveCircle size={28}></MdRemoveCircle>
              </ImageRemover>
            </ImageContentsWrapper>
          </ContentsWrapper>
        );
      } else {
        contents.push(
          <ContentsWrapper key={prop}>
            <ImageLoadLabel htmlFor={`__UploadLocalImage__${prop}`}>
              <MdAddCircleOutline size={40}></MdAddCircleOutline>
            </ImageLoadLabel>
            <input
              id={`__UploadLocalImage__${prop}`}
              accept={supportImageExt}
              type="file"
              index={prop}
              hidden
              onChange={loadImage}
            />
          </ContentsWrapper>
        );
      }
    }
    return contents;
  };

  return (
    <Dialog isNoHeader isShow={isShow}>
      <DialogBody>
        <DialogContents>
          <TitleWrapper>{t('ActiveLink.InsertImageGrid')}</TitleWrapper>
          <ContentItem>
            <ContentLabel>{t('ActiveLink.SelectImage')}</ContentLabel>
            <SelectImageWrapper>
              <GridLayout column={3} gap={6}>
                {getImageAreaContents()}
              </GridLayout>
            </SelectImageWrapper>
          </ContentItem>
          <ContentItem>
            <ContentLabel>{t('ActiveLink.Layout')}</ContentLabel>
            <LayoutList>
              <GridLayout
                column={3}
                gap={6}
                cssExt={css`
                  row-gap: 25px;
                `}>
                {getLayout()}
              </GridLayout>
            </LayoutList>
          </ContentItem>
        </DialogContents>
        <ActiveLinkDialogFooter onSubmit={onClickSubmit}></ActiveLinkDialogFooter>
      </DialogBody>
    </Dialog>
  );
}
